<style scoped>
	#app {
		padding: 20px;
	}
	.header {
		line-height: 60px;
		font-size: 16px;
		font-weight: bold;
		
	}
	.table-box {
		margin-top: 10px;
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
	}
	
	.table-header {
		padding: 15px 20px;
		font-size: 14px;
		font-weight: bold;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.box {
		background-color: white;
		width: 100%;
		border-radius: 3px;
		border:solid 1px #ECECEC;
		display: flex;
		flex-wrap: wrap;
		padding: 10px 0;
		font-size: 14px;
	}
	.form-item {
		height: 60px;
		width: 380px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}
	.form-name {
		width: 120px;
		text-align: right;
	}
	.inp {
		width: 280px;
	}
	.el-button--primary {
		background-color: #1677FF!important;
	}
	.dot {
		color: #52C51A;
		padding: 10px;
	}
	.il {
		display: flex;
		flex-direction: row;
	}
	.t-box {
		border: solid 1px #dcdcdc;
		padding: 0 4px;
		border-radius: 4px;
	}
	.t-box1 {
		border: solid 1px #3da113;
		color: #3da113;
		padding: 0 4px;
		border-radius: 4px;
		background-color: #F7FFFE;
	}
	.t-edit {
		font-size: 14px;
		padding: 0 4px;
		margin-left: 10px;
		cursor: pointer;
	}
	.t-a {
		color: #1677FF;
		text-decoration: underline;
		cursor: pointer;
	}
</style>
<template>
	<div id="app">
		<el-breadcrumb class="nav" separator="/" style="margin-bottom: 13px;">
			<el-breadcrumb-item>用户管理</el-breadcrumb-item>
			<el-breadcrumb-item>用户充值</el-breadcrumb-item>
		</el-breadcrumb>
		
		<div class="box" style="display: flex; flex-direction: column;">
			<div style="margin-left: 20px; display: flex; flex-direction: row; align-items: center; margin-bottom: 10px;">
				<div>订单信息：</div>
				<el-input placeholder="ID/订单号/外部订单号" v-model="search.keyword" clearable="" style="margin-right: 10px; width:300px;"></el-input>
				<div>会员信息：</div>
				<el-input placeholder="会员账号/昵称/UID" v-model="search.user_keyword" clearable="" style="margin-right: 10px; width:200px;"></el-input>
				<div>店铺信息：</div>
				<el-input placeholder="店铺SID/店铺名" v-model="search.shop_keyword" clearable="" style="margin-right: 10px; width:230px;"></el-input>
			</div>	
			<div style="margin-left: 20px; display: flex; flex-direction: row; align-items: center;">
				<div>状态：</div>
				<div style="width: 120px;">
					<el-select v-model="search.status" clearable="" placeholder="全部状态" style="width: 120px;">
						<el-option key="all" label="已成功" :value="1"></el-option>
						<el-option key="add" label="待支付" :value="2"></el-option>
					</el-select>
				</div>
				<div style="margin-left: 20px;">通道：</div>
				<div >
					<el-select v-model="search.pay_code" clearable="" placeholder="全部通道" style="width: 220px;">
						<el-option v-for="(item, index) in payChannelList" :key="item.pay_code" :label="item.pay_name" :value="item.pay_code"></el-option>
					</el-select>
				</div>
				
				<div style="margin-left: 10px;">时间段：</div>
				<el-date-picker
				      v-model="search.dateTime"
				      type="daterange"
				      align="right"
				      unlink-panels
				      range-separator="至"
				      start-placeholder="开始日期"
				      end-placeholder="结束日期"
					  value-format="yyyy-MM-dd"
				      :picker-options="pickerOptions">
				</el-date-picker>
				
				<el-button style="margin-left: 20px;" size="mini" type="primary" @click="getData()">搜索</el-button>
				
				<div style="margin-left: 20px;">总计：{{totalAmount}} 元</div>
			</div>
		</div>
		
		<div class="table-box">
			<el-table :data="tableData" border 
				v-loading="loading"
				element-loading-text="拼命加载中"
				element-loading-spinner="el-icon-loading"
				element-loading-background="rgba(0, 0, 0, 0.8)" >
			    <el-table-column prop="ID" label="编号" align="center" width="100">
					<template slot-scope="scope">
						{{scope.row.id}}
					</template>
				</el-table-column>
				<el-table-column prop="sid" label="店铺" align="center" width="160">
					<template slot-scope="scope">
						{{scope.row.shop_name}}<span style="color: #999999;">({{scope.row.sid}})</span>
					</template>
				</el-table-column>
				<el-table-column prop="nickname" label="会员昵称" align="center" width="120">
				</el-table-column>
				<el-table-column prop="username" label="会员账号" align="center" width="160">
					<template slot-scope="scope">
						{{scope.row.username}}<span style="color: #999999;">({{scope.row.uid}})</span>
					</template>
				</el-table-column>
				<el-table-column prop="amount" label="充值金额" align="center" width="120">
				</el-table-column>
				<el-table-column prop="pay_code" label="充值渠道" align="center" width="120">
				</el-table-column>
				<el-table-column prop="status" label="状态" align="center" width="140">
					<template slot-scope="scope">
						<el-tag type="info"  v-if="scope.row.status==0" size="mini">待确认</el-tag>
						<el-tag type="success" v-if="scope.row.status==1" size="mini">充值成功</el-tag>
						<el-tag type="error" v-if="scope.row.status==2" size="mini">充值拒绝</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="add_time" label="充值时间"  align="center" width="180">
					<template slot-scope="scope">
						{{formatTimestamp(scope.row.add_time)}}
					</template>
				</el-table-column>
				<el-table-column prop="action_time" label="到账时间" align="center" width="180">
					<template slot-scope="scope">
						{{formatTimestamp(scope.row.action_time)}}
					</template>
				</el-table-column>
				<el-table-column prop="action_time" label="系统单号" align="center" width="240">
					<template slot-scope="scope">
						{{scope.row.orderSn}}
					</template>
				</el-table-column>
				<el-table-column prop="action_time" label="三方单号" align="center" width="300">
					<template slot-scope="scope">
						{{scope.row.out_order_sn}}
					</template>
				</el-table-column>
				
			  </el-table>
			  
			  <div  style="flex-grow: 1; display: flex; flex-direction: row; justify-content: flex-end; margin: 10px 10px 10px 0;">
			  <el-pagination
			        @size-change="handleSizeChange"
			        @current-change="handleCurrentChange"
			        :current-page="currentPage"
			        :page-sizes="[14, 20, 50, 100]"
			        :page-size="limit"
			        layout="total, sizes, prev, pager, next, jumper"
			        :total="total">
			      </el-pagination>
			  </div>
		</div>
		
	</div> 
</template>

<script>
	
	export default {
		components: {
		},  
		computed:{
		},
		data(){
			return {
				payChannelList:[],
				pickerOptions: {
				  shortcuts: [{
					text: '最近一周',
					onClick(picker) {
					  const end = new Date();
					  const start = new Date();
					  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
					  picker.$emit('pick', [start, end]);
					}
				  }, {
					text: '最近一个月',
					onClick(picker) {
					  const end = new Date();
					  const start = new Date();
					  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
					  picker.$emit('pick', [start, end]);
					}
				  }, {
					text: '最近三个月',
					onClick(picker) {
					  const end = new Date();
					  const start = new Date();
					  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
					  picker.$emit('pick', [start, end]);
					}
				  }]
				},
				totalAmount:0,
				search:{
					keyword:'',
					user_keyword:'',
					shop_keyword:'',
					status:'',
					dateTime:[],
					pay_code:'',
				},
				loading:false,
				currentPage:1,
				tableData: [],
				total:0,
				limit:20,
				detailShow:false,
				viewOrid:0,
			}
		},
		created() {
			this.getPayChannel();
			this.getData();
		},
		methods:{
			viewOrder(scope){
				// this.viewOrid = scope.row.orid;
				// this.detailShow = true;
			},
			closeShow(){
				this.detailShow = false;
			},
			getPayChannel(){
				let _this = this;
				_this.loading = true;
				_this.$api.post("/Recharge/getUserPayChannel", {}).then(res=>{
					_this.loading = false;
					if(res.code == 200){
						_this.payChannelList = res.data.list;
					}else{
					}
				}).catch(res=>{
					_this.loading = false;
				});
			},
			deleteApi(scope){
				let _this = this;
				_this.loading = true;
				_this.$api.post("/Order/deleteOrder", {orid:scope.row.orid}).then(res=>{
					_this.loading = false;
					if(res.code == 200){
						_this.tableData.splice(scope.$index, 1);
						_this.$message({ message: '删除成功', type: 'success', });
					}else{
						_this.$message({ message: '删除失败', type: 'warning', });
					}
				}).catch(res=>{
					_this.loading = false;
				});
			},
			deleteFunc(scope){
				let _this = this;
				this.$confirm('是否确认删除此订单？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_this.deleteApi(scope);
				}).catch(() => {      
				});
			},
			reset(){
				this.search = {
					keyword:'',
					user_keyword:'',
					shop_keyword:'',
					status:'99',
					gameType:'99'
				}
				this.getData();
			},
			getData(){
				let that = this;
				that.loading = true;
				that.$api.post("/User/getUserPayList", {page:this.currentPage, limit:this.limit, ...this.search}).then(res=>{
					that.loading = false;
					that.tableData = res.data.list;
					that.total = res.data.total;
					that.totalAmount = res.data.totalAmount;
				}).catch(res=>{
					that.loading = false;
				});
			},
			handleSizeChange(e){
				this.limit = e;
				this.getData();
			},
			handleCurrentChange(e){
				this.currentPage = e;
				this.getData();
			},
			formatTimestamp(ts) {
				if(ts == 0){
					return '';
				}
				// 如果是 10 位（秒），需要乘 1000 变成毫秒
				if (ts.toString().length === 10) {
					ts *= 1000
				}
				const date = new Date(ts)
			
				const Y = date.getFullYear()
				const M = String(date.getMonth() + 1).padStart(2, '0')
				const D = String(date.getDate()).padStart(2, '0')
			
				const h = String(date.getHours()).padStart(2, '0')
				const m = String(date.getMinutes()).padStart(2, '0')
				const s = String(date.getSeconds()).padStart(2, '0')
			
				return `${Y}-${M}-${D} ${h}:${m}:${s}`
			},
		}
	}
</script>

